/* eslint-disable class-methods-use-this */
import axios, { AxiosResponse } from 'axios';

import type {
  Enquiry,
  EnquiryGateway,
  MakeEnquiryResponse,
} from '../types/Enquiries';

export class ApiEnquiryGateway implements EnquiryGateway {
  async submit(enquiry: Enquiry): Promise<MakeEnquiryResponse> {
    const url = new URL('/api/enquiries/make-enquiry', window.location.origin);

    try {
      await axios.post<MakeEnquiryResponse>(url.toString(), enquiry);
      return {};
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const response = err.response as AxiosResponse<MakeEnquiryResponse>;
        if (response.data.error !== undefined) {
          return { error: response.data.error };
        }
      }

      throw err;
    }
  }
}
